import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=ab16b57c&scoped=true"
import script from "./addressDetail.vue?vue&type=script&lang=js"
export * from "./addressDetail.vue?vue&type=script&lang=js"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=ab16b57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab16b57c",
  null
  
)

export default component.exports